import { Eraser } from 'lucide-react';
import type { ValidationExpectedData } from '../../types/barcodeValidation';

interface Props {
  data: ValidationExpectedData;
  onFieldChange: (field: keyof ValidationExpectedData, value: string) => void;
  onClear: () => void;
}

const fields: { field: keyof ValidationExpectedData; label: string; placeholder: string }[] = [
  { field: 'gtin', label: 'GTIN', placeholder: 'Ex: 07891234567890' },
  { field: 'lote', label: 'Lote', placeholder: 'Ex: L1234' },
  { field: 'validade', label: 'Validade', placeholder: 'DD/MM/YYYY' },
  { field: 'serie', label: 'Serial', placeholder: 'Ex: SN001' },
  { field: 'dataProducao', label: 'Data Producao', placeholder: 'DD/MM/YYYY' },
  { field: 'melhorUso', label: 'Melhor Uso', placeholder: 'DD/MM/YYYY' },
  { field: 'quantidade', label: 'Quantidade', placeholder: 'Ex: 10' },
  { field: 'refCode', label: 'Ref Code (AI 240)', placeholder: 'Ex: REFCODE123' },
];

export function ExpectedDataForm({ data, onFieldChange, onClear }: Props) {
  return (
    <div className="bg-white rounded-xl border border-gray-200 shadow-sm p-5">
      <div className="flex items-center justify-between mb-3">
        <h2 className="text-lg font-semibold text-gray-800">Dados Esperados</h2>
        <button
          onClick={onClear}
          className="flex items-center gap-1.5 px-3 py-1.5 text-sm text-gray-600 hover:text-red-600 hover:bg-red-50 rounded-lg transition-colors"
        >
          <Eraser className="w-4 h-4" />
          Limpar
        </button>
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
        {fields.map((f) => (
          <div key={f.field}>
            <label className="block text-xs text-gray-500 font-medium mb-1">{f.label}</label>
            <input
              type="text"
              value={data[f.field]}
              onChange={(e) => onFieldChange(f.field, e.target.value)}
              placeholder={f.placeholder}
              className="w-full px-3 py-2 text-sm font-mono border border-gray-300 rounded-lg focus:ring-2 focus:ring-teal-500 focus:border-teal-500"
            />
          </div>
        ))}
      </div>
    </div>
  );
}
